import { Registration, User } from 'types/user';
import React from 'react';

const UserContext = React.createContext(
  {} as {
    user?: User;
    fetching: boolean;
    setUser: (t?: User) => any;
    // map challenge id to registration information
    registrations: Record<string, Registration>;
    getRegistration: (challengeId: string) => Promise<Registration>;
  }
);

export const UserProvider = UserContext.Provider;
export const UserConsumer = UserContext.Consumer;
export default UserContext;
